import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	total: 0,
	page: 1,
	maxPage: 1,
	users: [],
};

const customersSlice = createSlice({
	name: 'customers',
	initialState: initialState,
	reducers: {
		setCustomers: (state, action) => action.payload,
		reset: (state, action) => initialState,
	},
});

export const { setCustomers, reset } = customersSlice.actions;

export default customersSlice.reducer;